<app-tab-form-modal i18n-header header="Shipping Packs" [model$]="model$" (saveClicked)="save()">
  @if (outcome(); as outcome) {
    <p class="form-explanation" i18n>
      Despatch note {{ outcome.despatchNoteNo }} has been created for order {{ outcome.orderNo }}. Enter the weight of
      each pack, then save to book the shipping.
    </p>
    <app-base-form [fields]="fields()" [model]="formModel()"></app-base-form>
  }
</app-tab-form-modal>
